<ng-template dynamicComponent />
